import { createContext } from 'react';

export interface LoginModalOptions {
  initialMode?: 'login' | 'signup';
  initialView?: 'signup_personalInfo';
  initialUserType?: 'tutor' | 'parent';
  fromRegistration?: boolean;
  ignorePending?: boolean;
  registrationService?: 'academic' | 'music';
}

export interface CloseWarningConfig {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
}

export interface TutorRegistrationModalOptions {
  entryPoint?: 'default' | 'complete-profile';
}

export interface ModalContextType {
  // Login Modal
  showLoginModal: boolean;
  loginModalOptions?: LoginModalOptions;
  openLoginModal: (options?: LoginModalOptions) => void;
  closeLoginModal: () => void;

  // AI Match Modal
  showAIMatchModal: boolean;
  openAIMatchModal: () => void;
  closeAIMatchModal: () => void;

  // Tutor Registration Modal
  showTutorRegistration: boolean;
  tutorRegistrationOptions?: TutorRegistrationModalOptions;
  openTutorRegistration: (options?: TutorRegistrationModalOptions) => void;
  closeTutorRegistration: () => void;

  // Parent Registration Modal
  showParentRegistration: boolean;
  openParentRegistration: () => void;
  closeParentRegistration: () => void;

  showMusicTutorRegistration: boolean;
  openMusicTutorRegistration: () => void;
  closeMusicTutorRegistration: () => void;
  showMusicParentRegistration: boolean;
  openMusicParentRegistration: () => void;
  closeMusicParentRegistration: () => void;

  // Close Warning Modal
  showCloseWarning: boolean;
  closeWarningConfig?: CloseWarningConfig;
  openCloseWarning: (config?: CloseWarningConfig) => void;
  closeCloseWarning: () => void;
  onCloseWarningConfirm: (() => void) | null;
  setOnCloseWarningConfirm: (callback: (() => void) | null) => void;
}

export const ModalContext = createContext<ModalContextType | undefined>(undefined);
